import classnames from 'classnames'
import { Dispatch, SetStateAction } from 'react'
import { TDesktopDropDownOverlay } from '../HeaderV2/types/types'
import { MobileOverlayStateType } from './utils/types'
import Link from '@/components/Common/Link'
import { StencilCDNImage } from '@/components/Common/StencilImage'
import {
  BETA_INDSTOCKS_HOST,
  INDGLOBAL_HOST,
  INDSTOCKS_HOST,
} from '@/root/constants/common'
import { CDN_IMAGES } from '@/root/constants/image-links'

export default function Logo({
  disablePointer = false,
  host,
  toggleDwebDropdown,
  setOverlay,
}: {
  disablePointer?: boolean
  host?: string
  toggleDwebDropdown?: Dispatch<SetStateAction<TDesktopDropDownOverlay>>
  setOverlay?: Dispatch<SetStateAction<MobileOverlayStateType>>
}) {
  const showINDStocksLogo =
    host === INDSTOCKS_HOST || host === BETA_INDSTOCKS_HOST
  const showINDGlobalLogo = host === INDGLOBAL_HOST

  let logo = ''

  if (showINDStocksLogo) {
    logo = CDN_IMAGES.indstocksLogo
  } else if (showINDGlobalLogo) {
    logo = CDN_IMAGES.indGlobalLogo
  } else {
    logo = CDN_IMAGES.indmoneyRoundLogo
  }

  return (
    <Link
      href="/"
      className={classnames('flex items-center', {
        'pointer-events-none': disablePointer,
        'h-[44px] w-[44px]':
          logo === CDN_IMAGES.indmoneyRoundLogo ||
          logo === CDN_IMAGES.indstocksLogo,
      })}
      onClick={() => {
        if (toggleDwebDropdown) toggleDwebDropdown(null)
        if (setOverlay) setOverlay(null)
      }}
    >
      <StencilCDNImage
        src={logo}
        alt="INDmoney Logo"
        width={showINDGlobalLogo ? 100 : 44}
        height={showINDGlobalLogo ? 100 : 44}
        quality={100}
        unoptimized
        priority
      />
    </Link>
  )
}
